export default __webpack_public_path__ + "static/media/pp.81b038eb.jfif";